import { defineComponent as _defineComponent } from 'vue';
import { useVentureId } from '~/functions/accounts';
import { useAccountUsersPage } from '~/functions/account-users-page';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var ventureId = useVentureId();
    var _useAccountUsersPage = useAccountUsersPage({
        accountId: ventureId,
        allowIxAdmin: false
      }),
      loading = _useAccountUsersPage.loading,
      canAccess = _useAccountUsersPage.canAccess,
      isIxAdminSession = _useAccountUsersPage.isIxAdminSession,
      isAccountAdmin = _useAccountUsersPage.isAccountAdmin,
      listUsersFilter = _useAccountUsersPage.listUsersFilter,
      disableReviewerRole = _useAccountUsersPage.disableReviewerRole,
      userTableColumns = _useAccountUsersPage.userTableColumns;
    var accountId = computed(function () {
      return ventureId.value;
    });
    return {
      __sfc: true,
      ventureId: ventureId,
      loading: loading,
      canAccess: canAccess,
      isIxAdminSession: isIxAdminSession,
      isAccountAdmin: isAccountAdmin,
      listUsersFilter: listUsersFilter,
      disableReviewerRole: disableReviewerRole,
      userTableColumns: userTableColumns,
      accountId: accountId
    };
  }
});